import { type AxiosRequestConfig } from 'axios';
import instance from './axiosInstance';

export function getAccountDetails<T = any>(config?: AxiosRequestConfig) {
  return instance.get<T>('/account/details', config).then((resp) => resp.data);
}
